import crudActions from '../../crud/actions'

const actions = crudActions('SETTINGS_LISTS_SUPPORTTASKLIST_')

export default actions
